import { Collapse } from 'react-bootstrap';

import { Accordion } from 'components/Accordion/Accordion';
import { Input, ToggleLabel } from 'components/FormComponents';

const settingsHeader = <span className="text-neutral-7 text-xl font-medium">Settings</span>;

export const DefaultSettings = ({ register, name, field, noPlaceholder = false }) => (
  <div className="flex flex-col overflow-hidden">
    <Accordion defaultCollapsed={false} header={settingsHeader}>
      <div className="border border-neutral-4 rounded-2xl overflow-hidden">
        <div className="px-4 py-2 border-b border-neutral-4">
          <ToggleLabel
            className="text-neutral-6 text-xl font-medium"
            register={register}
            name={`${name}.required`}
            label="Required"
          />
        </div>
        {!noPlaceholder && (
          <div className="flex flex-col px-4 py-2 gap-2 border-b border-neutral-4">
            <span className="text-neutral-6 text-xl font-medium">Placeholder</span>
            <Input
              register={register}
              name={`${name}.placeholder`}
              placeholder="Enter placeholder..."
            />
          </div>
        )}
        <div className="flex flex-col px-4 py-2 gap-2">
          <ToggleLabel
            className="text-neutral-6 text-xl font-medium"
            register={register}
            name={`${name}.use_description`}
            label="Add description"
          />
          <Collapse in={field.use_description}>
            <div>
              <Input
                register={register}
                name={`${name}.description`}
                placeholder="Enter description..."
              />
            </div>
          </Collapse>
        </div>
      </div>
    </Accordion>
  </div>
);
